__turbopack_context__.v({
  "className": "Y67Foq_className",
  "variable": "Y67Foq_variable",
});
